import { Image } from '@educator/components/Image'
import { getBasePath } from '@educator/config/basePath'
import { GridBackground, Button } from '@mc/educator-design-system'
import { useTranslation } from '@mc/i18n'

export const CatchAllError = () => {
  const { t } = useTranslation('@mc/educator')
  const basePath = getBasePath()

  const handleReload = () => {
    window.location.reload()
  }

  return (
    <div className='tailwind-enabled'>
      <div className='relative flex min-h-screen flex-col items-center justify-center bg-edu-bg-primary'>
        <GridBackground variant='full' className='absolute inset-0' />

        <Image
          src={`${basePath}/images/executive-logo-one-line.svg`}
          alt={t('common.logo.alt')}
          width={297}
          height={25}
          className='absolute top-[67px] left-1/2 -translate-x-1/2'
        />

        <div className='relative flex flex-col items-center text-center'>
          <h1 className='m-0 text-[40px] leading-none font-black uppercase text-edu-fg-primary'>
            {t('catchAllError.title')}
          </h1>
          <p className='mt-4 text-body-1 leading-body-1 font-normal text-edu-fg-semi-dimmed'>
            {t('catchAllError.description')}
          </p>
          <Button
            kind='default'
            onClick={handleReload}
            className='mt-[29px] flex h-16 w-64 items-center justify-center px-8'
          >
            <span className='text-body-3 leading-body-3 font-bold'>
              {t('catchAllError.reloadCta')}
            </span>
          </Button>
        </div>
      </div>
    </div>
  )
}
